export default __webpack_public_path__ + "static/media/thumbnail3.4eb1da66.png";